import { dynamicPx } from 'components/common/Common';
import { vw } from 'pages/affiliatePartner/AffiliatePartner.style';
import React, { forwardRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { debounce, roll } from 'untils/auth';

const withForwardedRef = (Comp) => {
  const handle = (props, ref) => <Comp {...props} forwardedRef={ref} />;

  const name = Comp.displayName || Comp.name;
  handle.displayName = `withForwardedRef(${name})`;

  return forwardRef(handle);
};

const StickyInput = styled.div`
  background-color: rgba(191, 202, 240, 0.4);
  backdrop-filter: blur(6px);
  border-radius: ${vw(54)};
  padding: ${vw(8)};
  position: fixed;
  top: ${vw(120)};
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 9;
  transition: visibility 0.3s, opacity 0.3s;
  visibility: hidden;
  opacity: 0;
  &.active {
    visibility: visible;
    opacity: 1;
  }
  & > div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    background-color: #fff;
    box-shadow: 0px 4px 40px rgba(26, 42, 57, 0.24);
    border-radius: 5vmax;
    font-size: 18px;
    line-height: 22px;

    button {
      padding: ${dynamicPx({ minSize: 4, maxSize: 8 })} ${dynamicPx({ minSize: 16, maxSize: 32 })};
      white-space: nowrap;
      color: rgba(13, 17, 35, 0.48);

      &:not(:last-child) {
        border-right: 1px solid rgba(7, 19, 33, 0.08);
      }
      cursor: pointer;
      &:hover {
        color: #07080A;
      }
    }
    i {
      display: block;
      width: 40px;
      height: 40px;
      background-image: url('/imgs/svg/search-bg-blue.svg');
      &:hover {
        transform: scale(1.05);
      }
    }

    @media (max-width: 757px) {
      font-size: 14px;
      i {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

const StickyNav = ({ handleActionA, handleActionB, scrollOffset, forwardedRef, showInput, setShowInput, showInputTypes }) => {
  const scrollUpHandle = () => {
    setShowInput(true);
    roll(400);
  }

  useEffect(() => {
    let executeThing = true;
    const scrollHandle = debounce((e) => {
      if (!executeThing) return false;
      const scrollTop =
        (e.srcElement ? e.srcElement.documentElement.scrollTop : false) ||
        window.pageYOffset ||
        (e.srcElement ? e.srcElement.body.scrollTop : 0);
      if (scrollTop >= (scrollOffset || 500)) {
        setShowInput(showInputTypes.default);
      }
    }, 100);

    window.addEventListener('scroll', scrollHandle);

    return () => {
      executeThing = false;
      window.removeEventListener('scroll', scrollHandle);
    };
  }, [scrollOffset]);

  return (
    <StickyInput className={`${!showInput ? 'active' : ''}`} ref={forwardedRef}>
      <div>
        <button onClick={handleActionA}>Where from?</button>
        <button onClick={handleActionB}>Where to?</button>

        <button onClick={scrollUpHandle}>
          <i className="bg-image" />
        </button>
      </div>
    </StickyInput>
  );
};

export default withForwardedRef(StickyNav);
